export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.slider-area').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 30000,
    });

    //toggler
    $('.search-icon').click(function () {
      $('.searhbar-area').addClass('active')
      $('#search_input').focus();
    });
    $('.submitbtn, .search-close').click(function () {
      $('.searhbar-area').removeClass('active')
    });


    $('.humbergur-menu').click(function () {
      $('.navbar-collapse').addClass('active')
    });
    $('.navclose').click(function () {
      $('.navbar-collapse').removeClass('active')
    });
    $('#contactbtn').click(function () {
      $('.contact-section').toggle()
    });

    //Counter
    $('.counter').counterUp({
      delay: 10,
      time: 1000,
    });


    //Counter Slider
    $(window).on('load', function () {
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 768) {
        $('.multiple-slide').addClass('counter-slider');
        $('.multiple-slide').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        })
      } else {
        $('.multiple-slide').removeClass('counter-slider');
      }
    });

    //blog
    $('.main').on('click', '.calevir_loadmore', function (e) {
      e.preventDefault();
      var calevir_loadmore_params = { 'ajaxurl': '/wp-admin/admin-ajax.php', 'posts': '', 'current_page': '1', 'max_page': null };
      var button = $(this),
        data = {
          'action': 'loadmore',
          'page': calevir_loadmore_params.current_page,
        };
      $.ajax({
        url: calevir_loadmore_params.ajaxurl,
        data: data,
        type: 'POST',
        cache: false,
        dataType: 'JSON',
        beforeSend: function () {
          button.text('Loading...');
        },
        success: function (data) {
          if (data) {
            if (data.actiondata) {
              $('#blog-result').append(data.actiondata);
            }
            button.text('Load More Blogs');
            calevir_loadmore_params.current_page++;
            if (calevir_loadmore_params.current_page == button.data('num')) {
              button.remove();
            }
          } else {
            button.remove();
          }
        },
      });
    });

    $(window).on('resize', function () {
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 768) {
        $('.multiple-slide').addClass('counter-slider');
        $('.multiple-slide').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        })
      } else {
        $('.multiple-slide').removeClass('counter-slider');
      }
    });

    //Event Slider
    $('.event-slider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      adaptiveHeight: true,
      
    });

    'use strict';
    var offSetTop = 100;
    var $scrollToTopButton = $('.scrollToTop');
    //Check to see if the window is top if not then display button
    $(window).scroll(function () {
      if ($(this).scrollTop() > offSetTop) {
        $scrollToTopButton.fadeIn();
      } else {
        $scrollToTopButton.fadeOut();
      }
    });

    //Click event to scroll to top
    $scrollToTopButton.click(function () {
      $('html, body').animate({ scrollTop: 0 }, 800);
      return false;
    });


    $('.action').click(function () {
      $(this).parent().children().removeClass('active');
      $(this).addClass('active');
      $(this).parent().addClass('active');
    });

    $('.close').click(function () {
      $(this).parent().parent().parent().children().removeClass('active');
      $(this).parent().parent().parent().children().children().removeClass('active');
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js